<template lang="pug">
b-modal#updateOperatorSetting2(
  ref="updateOperatorSetting2"
  :title="$t('ui.combine.update_operator_setting')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.' + setting_key_display)").mb-0
      template(v-if="setting_key == 'bank'")
        b-form-select(
          v-model="setting_value"
          size="sm"
          :dirty="$v.setting_value.$dirty"
          :error="$v.setting_value.$error"
          )
          option(value="COMPANY") {{ $t('ui.company') }}
          option(value="OWN") {{ $t('ui.own') }}
      template(v-else-if="['currency', 'referee', 'referral', 'sos'].includes(setting_key)")
        DebounceInput(
          size="sm"
          ref="setting_value"
          required
          alphaNum
          type="text"
          :dirty="$v.setting_value.$dirty"
          :error="$v.setting_value.$error"
          v-model.trim.lazy="$v.setting_value.$model"
          :disabled="loading"
        )
      template(v-else-if="setting_key == 'payment_setting'")
        PaymentSetting(
          size="sm"
          ref="setting_value"
          type="text"
          :dirty="$v.setting_value.$dirty"
          :error="$v.setting_value.$error"
          v-model.trim.lazy="$v.setting_value.$model"
          :disabled="loading"
        )
      template(v-else)
        TurnoverRebate(
          size="sm"
          ref="setting_value"
          type="text"
          :dirty="$v.setting_value.$dirty"
          :error="$v.setting_value.$error"
          v-model.trim.lazy="$v.setting_value.$model"
          :disabled="loading"
        )
      ValidateResult(:value="$v.setting_value" :name="$tc('ui.value', 1)")
    template(v-if="!['turnover_rebate', 'referee', 'referral'].includes(setting_key)")
      template(v-if="!['payment_setting'].includes(setting_key)")
        //- b-form-group(:label="$tc('ui.remark', 1)").mb-0
        b-form-group(:label="setting_key != 'sos' ? $tc('ui.remark', 1) : $tc('ui.link')").mb-0
          DebounceInput(
            size="sm"
            ref="remark"
            type="text"
            :dirty="$v.remark.$dirty"
            :error="$v.remark.$error"
            v-model.trim.lazy="$v.remark.$model"
            :disabled="loading"
          )
          //- ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
          ValidateResult(:value="$v.remark" :name="setting_key != 'sos' ? $tc('ui.remark', 1) : $tc('ui.link')")
    template(v-else)
      b-form-group(:label="$t('ui.campaign_id')").mb-0
        CampaignLookup(
          size="sm"
          ref="campaign_id"
          :operatorID="operatorID"
          required
          type="array"
          :dirty="$v.campaign_id.$dirty"
          :error="$v.campaign_id.$error"
          v-model.trim.lazy="$v.campaign_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.campaign_id" :name="$t('ui.campaign_id')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import TurnoverRebate from "@/library/TurnoverRebate";
import CampaignLookup from "@/library/CampaignLookup";
import PaymentSetting from "@/library/PaymentSetting";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    TurnoverRebate,
    CampaignLookup,
    PaymentSetting
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      setting_key: "",
      setting_key_display: "",
      setting_value: "",
      remark: "",
      campaign_id: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    setting_value: {
      required
    },
    remark: {
      maxLength: helpers.withParams(
        { type: 'maxLengthIf' },
        function (value) {
          if (this.setting_key != 'sos') {
            return maxLength(20)(value)
          }
          return true
        }
      )
    },
    campaign_id: {

    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.operatorSettingUpdate2Url();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          setting_key: this.item.setting_key,
          setting_value: this.setting_value,
          remark: ['turnover_rebate', 'referee', 'referral'].includes(this.setting_key) ? this.campaign_id : this.remark
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.updateOperatorSetting2.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "update_operator_setting", this.feedback.status);
                  this.$refs.updateOperatorSetting2.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.setting_key = this.item.setting_key;
      this.setting_value = this.item.setting_value;
      this.remark = this.item.remark
      this.campaign_id = this.item.remark
      this.setting_key_display = this.setting_key
      if(this.setting_key_display == 'sos') {
        this.setting_key_display = 'sos_accumulate_deposit'
      }
      if(this.item.setting_key == 'turnover_rebate') {
        this.remark = ''
      }
      // this.$refs.setting_value.$el.focus();
    }
  }
};
</script>
